import EditIcon from "@mui/icons-material/Edit";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { applyMetricWeightTarget, macroGPerKgToGramsMetricMacrosRounded } from "@notemeal/shared-utils-macro-protocol";
import { EditMetricMacroProtocolState, getAnthropometrySnapshotFromAnthroInfoState } from "shared-ui/reducers/EditMacroProtocol";

interface MetricMacroProtocolViewProps {
  macroProtocol: EditMetricMacroProtocolState;
  onEdit: () => void;
}

export const MetricMacroProtocolView = ({ macroProtocol, onEdit }: MetricMacroProtocolViewProps) => {
  const { cho, pro, fat } = macroProtocol;
  const targetAnthroSnapshot = applyMetricWeightTarget(
    getAnthropometrySnapshotFromAnthroInfoState(macroProtocol.anthroInfo),
    macroProtocol.usingWeightTarget ? macroProtocol.weightTargetInKg : null
  );
  const { weightInKg } = targetAnthroSnapshot;
  const { cho: choGrams, pro: proGrams, fat: fatGrams, kcal } = macroGPerKgToGramsMetricMacrosRounded(cho, pro, fat, weightInKg);
  const choText = cho.usesPercent ? `${cho.percent}%` : `${cho.gPerKg} g/kg`;
  const proText = pro.usesPercent ? `${pro.percent}%` : `${pro.gPerKg} g/kg`;
  const fatText = fat.usesPercent ? `${fat.percent}%` : `${fat.gPerKg} g/kg`;

  return (
    <Box sx={{ px: 2, border: 1, borderRadius: 1, borderColor: "#D0D5DD", display: "flex", gap: 2, alignItems: "center" }}>
      <Typography variant="h3">Example Daily Macros</Typography>
      <Typography variant="body2">
        <Box sx={{ color: "cho.main" }} component={"span"}>
          CHO
        </Box>
        : {choGrams}g ({choText})
      </Typography>
      <Typography variant="body2">
        <Box sx={{ color: "pro.main" }} component={"span"}>
          PRO
        </Box>
        : {proGrams}g ({proText})
      </Typography>
      <Typography variant="body2">
        <Box sx={{ color: "fat.main" }} component={"span"}>
          FAT
        </Box>
        : {fatGrams}g ({fatText})
      </Typography>
      <Typography variant="body2">
        <span>Calories:</span>
        <span>{kcal} kcal</span>
      </Typography>
      <Tooltip title="Edit">
        <IconButton size="small" onClick={onEdit}>
          <EditIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
